<template>
  <div class="d-flex align-items-center">
    <span class="text-warning mr-2" v-if="habilitado">{{ pendiente }} s</span>
    <a href="#" class="btn btn-sm btn-light-warning font-weight-bold" @click.prevent="habilitado = !habilitado">
      <i class="fa p-0" :class="[habilitado ? 'fa-pause' : 'fa-play']"></i>
    </a>
  </div>
</template>

<script>
export default {
  name: "DashboardAutoRefresh",
  props: {
    intervaloSegundos: {
      type: Number,
      default: 300,
    },
  },
  data: function () {
    return {
      habilitado: true,
      pendiente: 300,
    };
  },
  created: function () {
    this.pendiente = this.intervaloSegundos;
    this._timer = setInterval(this.tick, 1000);
  },
  beforeDestroy: function () {
    clearInterval(this._timer);
  },
  methods: {
    tick: function () {
      if (!this.habilitado) return;

      this.pendiente -= 1;
      if (this.pendiente === 0) {
        this.$emit("refresh");
      }
      if (this.pendiente < 0) {
        this.pendiente = this.intervaloSegundos;
      }
    },
  },
};
</script>
